{
  "address": "F5JK739h8ADzhG5xGwezYcYVq4enYM1LPuCkbwQg13G2",
  "metadata": {
    "name": "staking",
    "version": "0.9.1",
    "spec": "0.1.0",
    "description": "Created with Anchor"
  },
  "instructions": [
    {
      "name": "close_position",
      "discriminator": [
        123,
        134,
        81,
        0,
        49,
        68,
        98,
        98
      ],
      "accounts": [
        {
          "name": "user_key",
          "writable": true,
          "signer": true,
          "relations": [
            "stake_account"
          ]
        },
        {
          "name": "stake_account_positions",
          "writable": true
        },
        {
          "name": "stake_account",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  97,
                  99,
                  99,
                  111,
                  117,
                  110,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "user_key"
              }
            ]
          }
        },
        {
          "name": "config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103,
                  95,
                  118,
                  51
                ]
              }
            ]
          }
        },
        {
          "name": "target_account",
          "writable": true,
          "optional": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  116,
                  97,
                  114,
                  103,
                  101,
                  116
                ]
              },
              {
                "kind": "const",
                "value": [
                  118,
                  111,
                  116,
                  105,
                  110,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "pool_authority",
          "signer": true,
          "optional": true
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "index",
          "type": "u8"
        },
        {
          "name": "target_with_parameters",
          "type": {
            "defined": {
              "name": "TargetWithParameters"
            }
          }
        },
        {
          "name": "amount",
          "type": "u64"
        }
      ]
    },
    {
      "name": "create_position",
      "discriminator": [
        48,
        215,
        197,
        153,
        96,
        203,
        180,
        133
      ],
      "accounts": [
        {
          "name": "user_key",
          "writable": true,
          "signer": true,
          "relations": [
            "stake_account"
          ]
        },
        {
          "name": "stake_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  97,
                  99,
                  99,
                  111,
                  117,
                  110,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "user_key"
              }
            ]
          }
        },
        {
          "name": "stake_account_positions",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  112,
                  111,
                  115,
                  105,
                  116,
                  105,
                  111,
                  110,
                  115
                ]
              },
              {
                "kind": "account",
                "path": "stake_account"
              }
            ]
          }
        },
        {
          "name": "target_account",
          "writable": true,
          "optional": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  116,
                  97,
                  114,
                  103,
                  101,
                  116
                ]
              },
              {
                "kind": "const",
                "value": [
                  118,
                  111,
                  116,
                  105,
                  110,
                  103
                ]
              }
            ]
          }
        },
        {
          "name": "stake_account_custody",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  100,
                  101,
                  112,
                  111,
                  115,
                  105,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "user_key"
              }
            ]
          }
        },
        {
          "name": "config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103,
                  95,
                  118,
                  51
                ]
              }
            ]
          }
        },
        {
          "name": "pool_authority",
          "signer": true,
          "optional": true
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "target_with_parameters",
          "type": {
            "defined": {
              "name": "TargetWithParameters"
            }
          }
        },
        {
          "name": "amount",
          "type": "u64"
        }
      ]
    },
    {
      "name": "create_stake_account",
      "discriminator": [
        105,
        24,
        131,
        19,
        201,
        250,
        157,
        73
      ],
      "accounts": [
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103,
                  95,
                  118,
                  51
                ]
              }
            ]
          }
        },
        {
          "name": "crunch_mint"
        },
        {
          "name": "deposit_authority",
          "docs": [
            "CHECK not used"
          ],
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  100,
                  101,
                  112,
                  111,
                  115,
                  105,
                  116,
                  95,
                  97,
                  117,
                  116,
                  104,
                  111,
                  114,
                  105,
                  116,
                  121
                ]
              },
              {
                "kind": "account",
                "path": "staking_account"
              }
            ]
          }
        },
        {
          "name": "user_deposit",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  100,
                  101,
                  112,
                  111,
                  115,
                  105,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "payer"
              }
            ]
          }
        },
        {
          "name": "staking_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  97,
                  99,
                  99,
                  111,
                  117,
                  110,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "payer"
              }
            ]
          }
        },
        {
          "name": "staking_account_positions",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  112,
                  111,
                  115,
                  105,
                  116,
                  105,
                  111,
                  110,
                  115
                ]
              },
              {
                "kind": "account",
                "path": "staking_account"
              }
            ]
          }
        },
        {
          "name": "rent",
          "address": "SysvarRent111111111111111111111111111111111"
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": []
    },
    {
      "name": "create_staking_governance_pool",
      "discriminator": [
        115,
        141,
        37,
        214,
        180,
        112,
        48,
        155
      ],
      "accounts": [
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103,
                  95,
                  118,
                  51
                ]
              }
            ]
          }
        },
        {
          "name": "staking_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  97,
                  99,
                  99,
                  111,
                  117,
                  110,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "payer"
              }
            ]
          }
        },
        {
          "name": "deposit_authority",
          "docs": [
            "CHECK not used"
          ],
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  100,
                  101,
                  112,
                  111,
                  115,
                  105,
                  116,
                  95,
                  97,
                  117,
                  116,
                  104,
                  111,
                  114,
                  105,
                  116,
                  121
                ]
              },
              {
                "kind": "account",
                "path": "staking_account"
              }
            ]
          }
        },
        {
          "name": "staking_pool",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  112,
                  111,
                  111,
                  108,
                  95,
                  103,
                  111,
                  118,
                  101,
                  114,
                  110,
                  97,
                  110,
                  99,
                  101
                ]
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": []
    },
    {
      "name": "create_streamflow_metadata",
      "discriminator": [
        129,
        76,
        189,
        124,
        125,
        25,
        209,
        212
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "staking_account",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  97,
                  99,
                  99,
                  111,
                  117,
                  110,
                  116
                ]
              },
              {
                "kind": "arg",
                "path": "streamflow_owner_wallet"
              }
            ]
          }
        },
        {
          "name": "config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103,
                  95,
                  118,
                  51
                ]
              }
            ]
          }
        },
        {
          "name": "streamflow_metadata",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  114,
                  101,
                  97,
                  109,
                  102,
                  108,
                  111,
                  119,
                  95,
                  109,
                  101,
                  116,
                  97,
                  100,
                  97,
                  116,
                  97
                ]
              },
              {
                "kind": "account",
                "path": "staking_account"
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "streamflow_owner_wallet",
          "type": "pubkey"
        },
        {
          "name": "streamflow_account_key",
          "type": "pubkey"
        }
      ]
    },
    {
      "name": "create_voter_record",
      "discriminator": [
        3,
        12,
        113,
        222,
        177,
        4,
        152,
        165
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "staking_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  97,
                  99,
                  99,
                  111,
                  117,
                  110,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ]
          }
        },
        {
          "name": "staking_positions",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  112,
                  111,
                  115,
                  105,
                  116,
                  105,
                  111,
                  110,
                  115
                ]
              },
              {
                "kind": "account",
                "path": "staking_account"
              }
            ]
          }
        },
        {
          "name": "voter_record",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  118,
                  111,
                  116,
                  101,
                  114,
                  95,
                  114,
                  101,
                  99,
                  111,
                  114,
                  100
                ]
              },
              {
                "kind": "account",
                "path": "staking_positions"
              }
            ]
          }
        },
        {
          "name": "config",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103,
                  95,
                  118,
                  51
                ]
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": []
    },
    {
      "name": "init_config",
      "discriminator": [
        23,
        235,
        115,
        232,
        168,
        96,
        1,
        231
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "config",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103,
                  95,
                  118,
                  51
                ]
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "config",
          "type": {
            "defined": {
              "name": "StakingConfig"
            }
          }
        }
      ]
    },
    {
      "name": "mark_staking_account_as_coordinator",
      "discriminator": [
        210,
        208,
        58,
        6,
        117,
        102,
        100,
        253
      ],
      "accounts": [
        {
          "name": "signer",
          "signer": true
        },
        {
          "name": "config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103,
                  95,
                  118,
                  51
                ]
              }
            ]
          }
        },
        {
          "name": "staking_account",
          "writable": true
        }
      ],
      "args": []
    },
    {
      "name": "set_coordinator_stake_account",
      "discriminator": [
        249,
        39,
        43,
        237,
        53,
        62,
        246,
        142
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "staking_account"
        }
      ],
      "args": [
        {
          "name": "coordinator_pda",
          "type": "pubkey"
        }
      ]
    },
    {
      "name": "update_config",
      "discriminator": [
        29,
        158,
        252,
        191,
        10,
        83,
        219,
        99
      ],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "config",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103,
                  95,
                  118,
                  51
                ]
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "config",
          "type": {
            "defined": {
              "name": "StakingConfig"
            }
          }
        }
      ]
    },
    {
      "name": "update_voter_weight",
      "discriminator": [
        92,
        35,
        133,
        94,
        230,
        70,
        14,
        157
      ],
      "accounts": [
        {
          "name": "signer",
          "signer": true
        },
        {
          "name": "staking_account",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  97,
                  99,
                  99,
                  111,
                  117,
                  110,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "signer"
              }
            ]
          }
        },
        {
          "name": "staking_positions",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  112,
                  111,
                  115,
                  105,
                  116,
                  105,
                  111,
                  110,
                  115
                ]
              },
              {
                "kind": "account",
                "path": "staking_account"
              }
            ]
          }
        },
        {
          "name": "voter_record",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  118,
                  111,
                  116,
                  101,
                  114,
                  95,
                  114,
                  101,
                  99,
                  111,
                  114,
                  100
                ]
              },
              {
                "kind": "account",
                "path": "staking_positions"
              }
            ]
          }
        },
        {
          "name": "streamflow_metadata",
          "optional": true
        },
        {
          "name": "streamflow_account",
          "optional": true
        },
        {
          "name": "config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103,
                  95,
                  118,
                  51
                ]
              }
            ]
          }
        }
      ],
      "args": [
        {
          "name": "action",
          "type": {
            "defined": {
              "name": "VoterWeightAction"
            }
          }
        }
      ]
    },
    {
      "name": "withdraw",
      "discriminator": [
        183,
        18,
        70,
        156,
        148,
        109,
        161,
        34
      ],
      "accounts": [
        {
          "name": "payer",
          "writable": true,
          "signer": true
        },
        {
          "name": "staking_config",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  99,
                  111,
                  110,
                  102,
                  105,
                  103,
                  95,
                  118,
                  51
                ]
              }
            ]
          }
        },
        {
          "name": "crunch_mint"
        },
        {
          "name": "deposit_authority",
          "docs": [
            "CHECK not used"
          ],
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  100,
                  101,
                  112,
                  111,
                  115,
                  105,
                  116,
                  95,
                  97,
                  117,
                  116,
                  104,
                  111,
                  114,
                  105,
                  116,
                  121
                ]
              },
              {
                "kind": "account",
                "path": "staking_account"
              }
            ]
          }
        },
        {
          "name": "user_wallet",
          "writable": true
        },
        {
          "name": "user_deposit",
          "writable": true
        },
        {
          "name": "staking_account",
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  115,
                  116,
                  97,
                  107,
                  105,
                  110,
                  103,
                  95,
                  97,
                  99,
                  99,
                  111,
                  117,
                  110,
                  116
                ]
              },
              {
                "kind": "account",
                "path": "payer"
              }
            ]
          }
        },
        {
          "name": "token_program",
          "address": "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
        }
      ],
      "args": [
        {
          "name": "amount",
          "type": "u64"
        }
      ]
    }
  ],
  "accounts": [
    {
      "name": "StakingAccount",
      "discriminator": [
        52,
        178,
        251,
        157,
        180,
        186,
        98,
        234
      ]
    },
    {
      "name": "StakingConfig",
      "discriminator": [
        45,
        134,
        252,
        82,
        37,
        57,
        84,
        25
      ]
    },
    {
      "name": "StakingPoolGovernance",
      "discriminator": [
        230,
        240,
        196,
        78,
        145,
        242,
        163,
        130
      ]
    },
    {
      "name": "StakingPositions",
      "discriminator": [
        131,
        122,
        43,
        21,
        211,
        48,
        120,
        64
      ]
    },
    {
      "name": "StreamflowMetadata",
      "discriminator": [
        234,
        61,
        101,
        227,
        207,
        81,
        54,
        2
      ]
    },
    {
      "name": "TargetMetadata",
      "discriminator": [
        157,
        23,
        139,
        117,
        181,
        44,
        197,
        130
      ]
    },
    {
      "name": "VoterWeightRecord",
      "discriminator": [
        46,
        249,
        155,
        75,
        153,
        248,
        116,
        9
      ]
    }
  ],
  "errors": [
    {
      "code": 6000,
      "name": "InsufficientCRNCHTokens",
      "msg": "Insufficient CRNCH Tokens"
    },
    {
      "code": 6001,
      "name": "InsufficientShares",
      "msg": "Insufficient Shares"
    },
    {
      "code": 6002,
      "name": "OnlyAdminCanUpdateConfig",
      "msg": "Only Admin Can Update Config"
    },
    {
      "code": 6003,
      "name": "OnlyAdminAllowed",
      "msg": "Only Admin Allowed"
    },
    {
      "code": 6004,
      "name": "StakingPoolNotFound",
      "msg": "Staking Pool Not Found"
    },
    {
      "code": 6005,
      "name": "StakingPoolPositionNotFound",
      "msg": "Staking Pool Position Not Found"
    },
    {
      "code": 6006,
      "name": "GenericOverflow",
      "msg": "An arithmetic operation unexpectedly overflowed"
    },
    {
      "code": 6007,
      "name": "ZeroEpochDuration",
      "msg": "Epoch duration is 0"
    },
    {
      "code": 6008,
      "name": "CheckpointAlreadyPaidOut",
      "msg": "Checkpoint staking rewards has already been paid out"
    },
    {
      "code": 6009,
      "name": "CheckpointCoordinatorMismatch",
      "msg": "Checkpoint coordinator does not match staking pool coordinator"
    },
    {
      "code": 6010,
      "name": "NoStakersInPool",
      "msg": "No stakers in pool to distribute rewards"
    },
    {
      "code": 6011,
      "name": "StreamflowAddressMismatch",
      "msg": "Streamflow address in the metadata does not match the provided account"
    },
    {
      "code": 6012,
      "name": "StreamflowMetadataRequired",
      "msg": "Streamflow metadata account is required when providing a streamflow address"
    },
    {
      "code": 6013,
      "name": "InvalidStreamDataSize",
      "msg": "Stream metadata account has an unexpected size"
    },
    {
      "code": 6014,
      "name": "BorrowFailed",
      "msg": "Failed to borrow account data"
    },
    {
      "code": 6015,
      "name": "InvalidStreamData",
      "msg": "Stream metadata data is malformed"
    },
    {
      "code": 6016,
      "name": "PositionSerDe",
      "msg": "Error deserializing position"
    },
    {
      "code": 6017,
      "name": "PositionOutOfBounds",
      "msg": "Position out of bounds"
    },
    {
      "code": 6018,
      "name": "TooManyPositions",
      "msg": "Number of position limit reached"
    },
    {
      "code": 6019,
      "name": "InvalidSlashRatio",
      "msg": "The slash ratio should be between 0 and 1"
    },
    {
      "code": 6020,
      "name": "CreateEmptyPosition",
      "msg": "You cannot create an empty position"
    },
    {
      "code": 6021,
      "name": "MissingTargetAccount",
      "msg": "The target account is missing"
    },
    {
      "code": 6022,
      "name": "OnlyCoordinatorTargetAccountSupported",
      "msg": "Only coordinator target accounts are supported"
    },
    {
      "code": 6023,
      "name": "InvalidPoolAuthority",
      "msg": "The pool authority hasn't been passed or doesn't match the target"
    },
    {
      "code": 6024,
      "name": "TooMuchExposureToCoordinatorPool",
      "msg": "Too much exposure to coordinator pool"
    },
    {
      "code": 6025,
      "name": "ClosePositionWithZero"
    },
    {
      "code": 6026,
      "name": "UnexpectedTargetAccount"
    },
    {
      "code": 6027,
      "name": "AmountBiggerThanPosition"
    },
    {
      "code": 6028,
      "name": "PositionNotInUse"
    },
    {
      "code": 6029,
      "name": "WrongTarget"
    }
  ],
  "types": [
    {
      "name": "StakingAccount",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "authority_bump",
            "type": "u8"
          },
          {
            "name": "user_key",
            "type": "pubkey"
          },
          {
            "name": "coordinator_key",
            "type": "pubkey"
          },
          {
            "name": "voter_bump",
            "type": "u8"
          },
          {
            "name": "bump",
            "type": "u8"
          },
          {
            "name": "next_index",
            "type": "u8"
          }
        ]
      }
    },
    {
      "name": "StakingConfig",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "bump",
            "type": "u8"
          },
          {
            "name": "crnch_mint",
            "type": "pubkey"
          },
          {
            "name": "staking_admin_authority",
            "type": "pubkey"
          },
          {
            "name": "pool_authority",
            "type": "pubkey"
          },
          {
            "name": "crnch_governance_realm",
            "type": "pubkey"
          }
        ]
      }
    },
    {
      "name": "StakingPoolGovernance",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "total_staked",
            "type": "u64"
          },
          {
            "name": "bump",
            "type": "u8"
          }
        ]
      }
    },
    {
      "name": "StakingPosition",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "crnch_staked",
            "type": "u64"
          },
          {
            "name": "activation_epoch",
            "type": "u64"
          },
          {
            "name": "unlocking_start",
            "type": {
              "option": "u64"
            }
          },
          {
            "name": "shares_acquired",
            "type": "u64"
          },
          {
            "name": "target_with_parameters",
            "type": {
              "defined": {
                "name": "TargetWithParameters"
              }
            }
          }
        ]
      }
    },
    {
      "name": "StakingPositions",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "stake_account_key",
            "type": "pubkey"
          },
          {
            "name": "positions",
            "type": {
              "vec": {
                "defined": {
                  "name": "StakingPosition"
                }
              }
            }
          },
          {
            "name": "total_crnch_staked",
            "type": "u64"
          },
          {
            "name": "bump",
            "type": "u8"
          }
        ]
      }
    },
    {
      "name": "StreamflowMetadata",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "streamflow_owner_wallet",
            "type": "pubkey"
          },
          {
            "name": "streamflow_address",
            "type": "pubkey"
          },
          {
            "name": "bump",
            "type": "u8"
          }
        ]
      }
    },
    {
      "name": "TargetMetadata",
      "docs": [
        "This represents a target that users can stake to",
        "Currently we store the last time the target account was updated, the current locked balance",
        "and the amount by which the locked balance will change in the next epoch"
      ],
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "bump",
            "type": "u8"
          },
          {
            "name": "last_update_at",
            "type": "u64"
          },
          {
            "name": "prev_epoch_locked",
            "type": "u64"
          },
          {
            "name": "locked",
            "type": "u64"
          },
          {
            "name": "delta_locked",
            "type": "i64"
          }
        ]
      }
    },
    {
      "name": "TargetWithParameters",
      "type": {
        "kind": "enum",
        "variants": [
          {
            "name": "CoordinatorPool",
            "fields": [
              {
                "name": "coordinator",
                "type": "pubkey"
              }
            ]
          },
          {
            "name": "Voting"
          }
        ]
      }
    },
    {
      "name": "VoterWeightAction",
      "docs": [
        "The governance action VoterWeight is evaluated for"
      ],
      "type": {
        "kind": "enum",
        "variants": [
          {
            "name": "CastVote"
          },
          {
            "name": "CommentProposal"
          },
          {
            "name": "CreateGovernance"
          },
          {
            "name": "CreateProposal"
          },
          {
            "name": "SignOffProposal"
          }
        ]
      }
    },
    {
      "name": "VoterWeightRecord",
      "docs": [
        "Copied this struct from https://github.com/solana-labs/solana-program-library/blob/master/governance/addin-api/src/voter_weight.rs",
        "Anchor has a macro (vote_weight_record) that is supposed to generate this struct, but it doesn't",
        "work because the error's macros are not updated for anchor 0.22.0.",
        "Even if it did work, the type wouldn't show up in the IDL. SPL doesn't produce an API, which",
        "means that means we'd need the equivalent of this code on the client side.",
        "If Anchor fixes the macro, we might consider changing it"
      ],
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "realm",
            "docs": [
              "VoterWeightRecord discriminator sha256(\"account:VoterWeightRecord\")[..8]",
              "Note: The discriminator size must match the addin implementing program discriminator size",
              "to ensure it's stored in the private space of the account data and it's unique",
              "pub account_discriminator: [u8; 8],",
              "The Realm the VoterWeightRecord belongs to"
            ],
            "type": "pubkey"
          },
          {
            "name": "governing_token_mint",
            "docs": [
              "Governing Token Mint the VoterWeightRecord is associated with",
              "Note: The addin can take deposits of any tokens and is not restricted to the community or",
              "council tokens only"
            ],
            "type": "pubkey"
          },
          {
            "name": "governing_token_owner",
            "docs": [
              "The owner of the governing token and voter",
              "This is the actual owner (voter) and corresponds to TokenOwnerRecord.governing_token_owner"
            ],
            "type": "pubkey"
          },
          {
            "name": "voter_weight",
            "docs": [
              "Voter's weight",
              "The weight of the voter provided by the addin for the given realm, governing_token_mint and",
              "governing_token_owner (voter)"
            ],
            "type": "u64"
          },
          {
            "name": "voter_weight_expiry",
            "docs": [
              "The slot when the voting weight expires",
              "It should be set to None if the weight never expires",
              "If the voter weight decays with time, for example for time locked based weights, then the",
              "expiry must be set As a common pattern Revise instruction to update the weight should",
              "be invoked before governance instruction within the same transaction and the expiry set",
              "to the current slot to provide up to date weight"
            ],
            "type": {
              "option": "u64"
            }
          },
          {
            "name": "weight_action",
            "docs": [
              "The governance action the voter's weight pertains to",
              "It allows to provided voter's weight specific to the particular action the weight is",
              "evaluated for When the action is provided then the governance program asserts the",
              "executing action is the same as specified by the addin"
            ],
            "type": {
              "option": {
                "defined": {
                  "name": "VoterWeightAction"
                }
              }
            }
          },
          {
            "name": "weight_action_target",
            "docs": [
              "The target the voter's weight  action pertains to",
              "It allows to provided voter's weight specific to the target the weight is evaluated for",
              "For example when addin supplies weight to vote on a particular proposal then it must",
              "specify the proposal as the action target When the target is provided then the",
              "governance program asserts the target is the same as specified by the addin"
            ],
            "type": {
              "option": "pubkey"
            }
          },
          {
            "name": "reserved",
            "docs": [
              "Reserved space for future versions"
            ],
            "type": {
              "array": [
                "u8",
                8
              ]
            }
          }
        ]
      }
    }
  ],
  "constants": [
    {
      "name": "DEPOSIT_AUTHORITY_SEED",
      "type": "string",
      "value": "\"deposit_authority\""
    },
    {
      "name": "DEPOSIT_SEED",
      "type": "string",
      "value": "\"deposit\""
    },
    {
      "name": "MAX_VOTER_RECORD_SEED",
      "type": "string",
      "value": "\"max_voter_record\""
    },
    {
      "name": "SQRT_BONDING_CURVE_SCALE",
      "type": "u64",
      "value": "5000000000000"
    },
    {
      "name": "STAKING_ACCOUNT_SEED",
      "type": "string",
      "value": "\"staking_account\""
    },
    {
      "name": "STAKING_CONFIG_SEED",
      "type": "string",
      "value": "\"staking_config_v3\""
    },
    {
      "name": "STAKING_POOL_GOVERNANCE_SEED",
      "type": "string",
      "value": "\"staking_pool_governance\""
    },
    {
      "name": "STAKING_POOL_SEED",
      "type": "string",
      "value": "\"staking_pool\""
    },
    {
      "name": "STAKING_POSITIONS_SEED",
      "type": "string",
      "value": "\"staking_positions\""
    },
    {
      "name": "STREAMFLOW_METADATA_SEED",
      "type": "string",
      "value": "\"streamflow_metadata\""
    },
    {
      "name": "TARGET_SEED",
      "type": "string",
      "value": "\"target\""
    },
    {
      "name": "TOLERANCE",
      "type": "u64",
      "value": "1000000"
    },
    {
      "name": "VOTER_RECORD_SEED",
      "type": "string",
      "value": "\"voter_record\""
    },
    {
      "name": "VOTING_TARGET_SEED",
      "type": "string",
      "value": "\"voting\""
    }
  ]
}